module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut.3945ff11.svg";